var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.329,
    height: 64.739,
    viewBox: "0 0 52.329 64.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location",
    transform: "translate(-386.96 -369.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M413.105,382.592a13.542,13.542,0,1,0,13.536,13.549,13.552,13.552,0,0,0-13.536-13.549Zm0,23.84A10.291,10.291,0,1,1,423.4,396.141a10.3,10.3,0,0,1-10.291,10.291Zm0,0",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Location-2",
    "data-name": "Location",
    d: "M413.105,369.692c-.305,0-.622,0-.927.013a26.14,26.14,0,0,0-24.754,31.045,8.386,8.386,0,0,0,.185.874,25.041,25.041,0,0,0,1.749,5.139c2.688,6.37,8.582,16.185,21.376,26.807a3.768,3.768,0,0,0,4.795,0c12.781-10.609,18.675-20.437,21.35-26.754a25.754,25.754,0,0,0,1.762-5.178c.079-.319.132-.583.172-.835a26.145,26.145,0,0,0-25.708-31.111Zm22.489,30.555c0,.026-.039.251-.132.662a23.832,23.832,0,0,1-1.563,4.6c-2.556,6.04-8.172,15.377-20.449,25.562a.535.535,0,0,1-.331.119.556.556,0,0,1-.331-.119c-12.278-10.2-17.907-19.536-20.476-25.615a22.746,22.746,0,0,1-1.55-4.556c-.08-.345-.12-.556-.133-.623,0-.026-.013-.053-.013-.079a23.346,23.346,0,0,1-.3-6.583,22.908,22.908,0,0,1,45.707,2.239A23.768,23.768,0,0,1,435.594,400.247Z",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.efce1c9d.svg";
export { ForwardRef as ReactComponent };